<template>
  <div class="mydialog big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <ReturnVisit
      :isFlag="return_visit"
      :businessId="consultId"
      :visitType="visitType"
      :visitName="visitName"
      :sms_type="1"
      :activeIndexDia="activeIndexDia"
    ></ReturnVisit>
    <div class="container">
      <div class="box">
        <div class="searchbox">
          <div class="item">
            <span>患者姓名</span>
            <el-input
              v-model="patient_name"
              style="width: 110px; margin-left: 5px"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>医生姓名</span>
            <el-input
              v-model="doctor_name"
              style="width: 110px; margin-left: 5px"
              @input="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span>所在省市</span>
            <el-select
              v-model="province_id"
              placeholder="请选择"
              @change="search"
              style="width: 140px; margin-left: 5px"
              clearable
            >
              <el-option
                v-for="item in proList"
                :key="item.province_id"
                :label="item.name"
                :value="item.province_id"
              ></el-option>
            </el-select>
          </div>
          <div class="item">
            <span>医生手机号</span>
            <el-input
              v-model="doctor_phone"
              style="width: 110px; margin-left: 5px"
              @input="search"
              clearable
            ></el-input>
          </div>

          <div class="item">
            <span>问诊类型</span>
            <el-select
              v-model="consult_type"
              placeholder="请选择"
              style="width: 170px; margin-left: 5px"
              @change="search"
            >
              <el-option
                v-for="item in consultTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-button
              type="info"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 20px;
              "
              @click="search"
              >查询</el-button
            >
          </div>
          <!-- <div class="item">
            <span>是否测试医生</span>
            <el-radio-group v-model="is_test"
                            @change="search"
                            style="margin-left: 5px">
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </div> -->
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="问诊发起时间/接诊时间" width="260px">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content" v-html="timeText(scope.row)"></div>
                  <div>
                    <!-- <div>{{ scope.row.pay_time }}</div> -->
                    <div v-if="scope.row.is_complain == 1">
                      <div>{{ scope.row.submit_time }}</div>
                      <div>------</div>
                    </div>
                    <div v-else>
                      <div>{{ scope.row.pay_time }}</div>
                      <div v-if="scope.row.status > 2">
                        {{ scope.row.agree_time }}
                      </div>
                      <div v-else>------</div>
                    </div>
                  </div>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              label="问诊费用"
              prop="consult_money"
            ></el-table-column>

            <el-table-column label="实付金额" prop="pay_money">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">
                    问诊费用:&nbsp;{{ scope.row.consult_money }}元<br />
                    优惠券:&nbsp;-{{ scope.row.coupon_money }}元<br />
                    礼品卡:&nbsp;-{{ scope.row.gift_money }}元<br />
                    合计:&nbsp;{{ scope.row.pay_money }}元<br />
                  </div>
                  <span>{{ scope.row.pay_money }}</span>
                </el-tooltip>
              </template>
            </el-table-column>

            <el-table-column label="患者信息">
              <template slot-scope="scope">
                <div>{{ scope.row.real_name }}</div>
                <div>
                  <span v-if="scope.row.patient_sex == 1">男</span>
                  <span v-if="scope.row.patient_sex == 2">女</span>
                  <span v-if="scope.row.patient_sex == 0">未知</span>
                  <span style="margin-left: 10px">{{ scope.row.age }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="科室"
              prop="department_name"
            ></el-table-column>

            <el-table-column label="医生信息">
              <template slot-scope="scope">
                <div
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor: pointer"
                >
                  {{ scope.row.doctor_name }}
                </div>
                <div>
                  <span v-if="scope.row.doctor_sex == 1">男</span>
                  <span v-if="scope.row.doctor_sex == 2">女</span>
                  <span v-if="!scope.row.doctor_sex">未知</span>
                  <span style="margin-left: 10px">{{ scope.row.title }}</span>
                </div>
                <div>{{ scope.row.phone }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="province_name"
              label="所在省市"
            ></el-table-column>

            <el-table-column label="咨询状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">待补充信息</span>
                <span v-if="scope.row.status == 2">待确认</span>
                <span v-if="scope.row.status == 3">咨询中</span>
              </template>
            </el-table-column>
            <el-table-column label="问诊类型">
              <template slot-scope="scope">
                <span
                  v-if="
                    scope.row.consult_type == 1 && scope.row.consult_types == 1
                  "
                  >患者问诊</span
                >
                <span v-if="scope.row.consult_type == 2">医生赠送</span>
                <span v-if="scope.row.consult_type == 3">诊后咨询</span>
                <span v-if="scope.row.consult_type == 4">预约视频</span>
                <span v-if="scope.row.consult_type == 5">极速问诊</span>
                <span
                  v-if="
                    scope.row.consult_type == 1 && scope.row.consult_types == 2
                  "
                  >视频问诊</span
                >
                <span
                  v-if="
                    scope.row.consult_type == 1 && scope.row.consult_types == 3
                  "
                  >电话问诊</span
                >
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="
                    toDetail(scope.row.consult_id, scope.row.consult_types)
                  "
                  :disabled="
                    module_id_array[0] ? !module_id_array.includes('50') : false
                  "
                  >查看记录</el-button
                >
                <el-button
                  @click="toReturn(scope.row.consult_id)"
                  type="text"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1315')
                      : false
                  "
                  >回访</el-button
                >
                <span
                  v-if="scope.row.consult_type != 3"
                  style="margin-left: 10px"
                >
                  <el-button
                    type="text"
                    v-if="
                      !(
                        Number(scope.row.pay_money) * 100 +
                        Number(scope.row.gift_money) * 100
                      ) / 100
                    "
                    @click="refundDia(scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('823')
                        : false
                    "
                    >退款</el-button
                  >
                  <el-button
                    type="text"
                    v-else
                    @click="refundDia(scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('822')
                        : false
                    "
                    >退款</el-button
                  >
                </span>
                <el-button
                  type="text"
                  @click="stopAsk(scope.row.consult_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('926')
                      : false
                  "
                  v-if="scope.row.status == 3"
                  >结束问诊</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
            style="margin: 20px 0"
          ></el-pagination>
        </div>

        <!-- 退款弹框 -->
        <el-dialog
          title="问诊退款"
          :visible.sync="refundShow"
          width="520px"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
          :before-close="beforeClose"
        >
          <div class="diaRefundbox">
            <div class="info-box">
              <div class="info-item">
                <p>
                  支付时间: <span>{{ refund_info.pay_time }}</span>
                </p>
                <p>
                  接诊时间: <span>{{ refund_info.agree_time }}</span>
                </p>
              </div>
              <div class="info-item">
                <p>
                  患者: <span>{{ refund_info.real_name }}</span>
                </p>
                <p>
                  医生: <span>{{ refund_info.doctor_name }}</span>
                </p>
              </div>
              <div class="info-item">
                <p>
                  问诊费用: <span>{{ refund_info.pay_money }}</span>
                </p>
              </div>
            </div>

            <div style="padding: 10px 10px 0 10px">
              <div
                style="text-align: left; padding-bottom: 10px"
                v-if="isPlatform"
              >
                当前医生未确认，费用承担方式：
              </div>
              <div style="text-align: left; padding-bottom: 10px" v-else>
                当前费用未结算，请选择费用承担方式：
              </div>
              <div style="display: flex; padding-left: 80px">
                <el-radio-group
                  v-model="refundForm.bear_type"
                  size="medium"
                  :disabled="isPlatform"
                >
                  <el-radio :label="1">平台承担</el-radio>
                  <el-radio :label="2">医生承担</el-radio>
                </el-radio-group>
              </div>
            </div>

            <div class="align-center">
              <span class="searchtitle">退款原因</span>
              <el-select
                v-model="refundForm.refund_desc"
                placeholder="请选择"
                size="medium"
                style="margin-left: 10px; width: 300px"
              >
                <el-option
                  v-for="item in reasonOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.label"
                >
                </el-option>
              </el-select>
            </div>

            <div class="align-center">
              <span class="searchtitle">备注</span>
              <el-input
                v-model="refundForm.refund_remark"
                style="margin-left: 10px; width: 300px"
                type="textarea"
                :rows="3"
                placeholder="请填写退款备注"
              ></el-input>
            </div>
            <div class="align-center" v-if="refund_info.pay_money > 0">
              <span class="searchtitle">验证码</span>
              <el-input
                v-model="refundForm.code"
                size="medium"
                style="margin-left: 10px; width: 200px"
                placeholder="请输入"
              ></el-input>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="getCode"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('820') : false
                "
                >{{ codeText }}</el-button
              >
            </div>
            <div
              v-if="refund_info.pay_money > 0"
              style="padding-right: 200px; color: #ff9000"
            >
              验证码有效时间3分钟
            </div>
            <div
              v-if="refund_info.pay_money > 0"
              style="padding-right: 200px; color: #ff9000"
            >
              平台将全额退费并结束问诊
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="cancelRefund">取 消</el-button>
            <el-button
              type="primary"
              :loading="isRefundOrder"
              @click="refundOrder"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import yewu from "../../../api/yewu";
import platform from "../../../api/platform";
import common from "../../../api/common";
import _ from "lodash";
import dayjs from "dayjs";
import DocMsg from "../../../components/common/DocMsg.vue";
import ReturnVisit from "../../../components/common/ReturnVisit.vue";

export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      patient_name: "",
      doctor_name: "",
      doctor_phone: "",
      consult_type: 0,
      province_id: "",
      proList: [],
      consultTypeOptions: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "患者问诊",
        },
        {
          value: 2,
          label: "医生赠送",
        },
        {
          value: 3,
          label: "诊后咨询",
        },
        {
          value: 4,
          label: "视频问诊",
        },
        {
          value: 5,
          label: "电话问诊",
        },
        {
          value: 6,
          label: "预约视频",
        },
        {
          value: 7,
          label: "极速问诊",
        },
      ],
      value: [],
      refundShow: false,
      isPlatform: false,
      refund_info: {},
      refundForm: {
        bear_type: 2,
        refund_remark: "",
        code: "",
        refund_desc: "未问诊退款",
      },
      reasonOptions: [
        {
          label: "未问诊退款",
          value: 0,
        },
        {
          label: "已问诊退款",
          value: 1,
        },
      ],
      codeText: "获取验证码",
      timer: null,
      isRefundOrder: false,
      doc_msg: false,
      doctorId: "",
      return_visit: false,
      consultId: 0,
      visitName: "consult",
      visitType: 4,
      activeIndexDia: "1",
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    admin_id() {
      return this.$store.state.login.userInfo.admin_id;
    },
  },
  components: {
    DocMsg,
    ReturnVisit,
  },
  created() {
    this.getProvince();
  },
  activated() {
    this.getList();
  },
  methods: {
    // 问诊接诊时间文案
    timeText(row) {
      let { status, submit_time, agree_time, pay_time, is_complain } = row;
      let submit_html = `<div>问诊发起时间:${
        is_complain == 1 ? submit_time : pay_time
      }</div>`;
      let agree_html =
        status > 2
          ? `<div>接诊时间:${agree_time}-${status}</div>`
          : `<div>接诊时间:------</div>`;
      let pay_html = `<div>支付时间:${pay_time}</div>`;
      return `${pay_html}${submit_html}${agree_html}`;
    },
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取省市列表
    getProvince() {
      this.axios
        .post("platform/platform/getProvinceCityDistrict")
        .then((res) => {
          this.proList = res.data.list;
        });
    },
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        patient_name: this.patient_name,
        doctor_name: this.doctor_name,
        doctor_phone: this.doctor_phone,
        consult_status: 1,
        over_type: this.value.length ? this.value.toString() : "0",
        consult_type: this.consult_type,
        province_id: this.province_id,
      };
      yewu
        .consultList(data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.submit_time = item.submit_time
                ? platform.timestampToTime(item.submit_time)
                : "---------";
              item.agree_time = item.agree_time
                ? platform.timestampToTime(item.agree_time)
                : "---------";
              item.pay_time = item.pay_time
                ? platform.timestampToTime(item.pay_time)
                : "---------";
              item.over_time = item.over_time
                ? platform.timestampToTime(item.over_time)
                : "";
              return item;
            });
            this.totalNum = res.data.total;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    toDetail(consult_id, consult_types) {
      this.$router.push({
        path: "wenzhendetail",
        query: {
          consult_id,
          consult_types,
        },
      });
    },
    // 退款
    refundDia(row) {
      // if (row.pay_money <= 0) {
      //   this.$message.warning('问诊费用大于0');
      //   return;
      // }
      console.log(row);
      this.isPlatform = row.status == 2;
      this.refund_info = row;
      this.refundShow = true;
    },
    // 退款弹窗关闭
    beforeClose(done) {
      this.cancelRefund();
      done();
    },
    // 获取验证码
    getCode: _.throttle(
      function () {
        if (!this.codeText.includes("获")) {
          this.$message.warning("验证码已发送");
          return;
        }
        if (this.refundForm.bear_type == "") {
          this.$message.warning("请选择费用承担方式");
          return;
        }

        if (this.refundForm.refund_remark == "") {
          this.$message.warning("请填写完内容");
          return;
        }

        let params = {};
        params = {
          type: 2,
          business_id: this.refund_info.consult_id,
          price: this.refund_info.pay_money,
          refund_desc: this.refundForm.refund_desc,
          bear_type: this.refundForm.bear_type,
        };

        common.refundverificode(params).then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success("发送成功");
            let time = 60;
            this.timer = window.setInterval(() => {
              if (!time) {
                this.restCode();
                return;
              }
              time -= 1;
              this.codeText = `${time}S`;
            }, 1000);
            this.$once("hook:beforeDestroy", function () {
              this.restCode();
            });
          }
        });
      },
      5000,
      { trailing: false }
    ),
    // 重置验证码
    restCode() {
      window.clearInterval(this.timer);
      this.codeText = "获取验证码";
    },
    // 确认退款
    refundOrder() {
      if (this.refundForm.bear_type == "") {
        this.$message.warning("请选择费用承担方式");
        return;
      }

      if (this.refundForm.refund_remark === "") {
        this.$message.warning("请填写退款备注");
        return;
      }
      if (this.refundForm.code === "" && this.refund_info.pay_money > 0) {
        this.$message.warning("请填写验证码");
        return;
      }
      this.isRefundOrder = true;

      let params = Object.assign(this.refundForm, {
        consult_id: this.refund_info.consult_id,
      });
      let interfaceStr = "";
      if (this.refund_info.pay_money <= 0) {
        interfaceStr = "refundZeroConsult";
        params = _.omit(params, ["code"]);
      } else {
        interfaceStr = "refundConsult";
      }
      yewu[interfaceStr](params)
        .then((res) => {
          let { code } = res;
          if (code === 0) {
            this.$message.success("退款成功");
            this.isRefundOrder = false;
            this.refund_info = {};
            this.getList();
            this.cancelRefund();
          }
        })
        .catch((err) => {
          this.isRefundOrder = false;
        });
    },
    // 取消退款
    cancelRefund() {
      this.refundShow = false;
      this.restCode();
      for (let key in this.refundForm) {
        this.refundForm[key] = "";
      }
      this.refundForm["refund_desc"] = "未问诊退款";
      this.refundForm["bear_type"] = 2;
    },
    //手动结束问诊
    stopAsk(consult_id) {
      this.$confirm(
        "请与患者、医生双方沟通确认后，再结束问诊。平台手工结束问诊，问诊费用将正常收取，不予退还。",
        "结束问诊",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          this.axios
            .post("platform/Consult/overConsult", { consult_id })
            .then((res) => {
              this.$message.success("已结束问诊");
              this.getList();
            });
        })
        .catch(() => {});
    },
    //回访
    toReturn(consult_id) {
      this.consultId = consult_id;
      this.return_visit = !this.return_visit;
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .item {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}
.diaRefundbox {
  .info-box {
    height: 110px;
    padding: 10px 20px;
    margin: 0;
    p {
      margin: 0;
      padding: 0;
      font-size: 15px;
    }
    span {
      font-size: 15px;
    }
    .info-item {
      display: flex;
      justify-content: space-between;
    }
  }
  .align-center {
    margin: 10px 0 10px;
    .searchtitle {
      width: 80px;
      text-align: right;
    }
  }
}
</style>
